import { render, staticRenderFns } from "./CartsSingle.vue?vue&type=template&id=053face0"
import script from "./CartsSingle.vue?vue&type=script&lang=js"
export * from "./CartsSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports